// Status-Tracker Konstanten

export const LIFECYCLE_STRATEGIES = [
    {
        value: "HOLD",
        label: "Hold",
        short: "Langfristig halten",
        description: "Langfristiger Bestand — Cashflow-orientiert.",
        color: "emerald",
        bg: "bg-emerald-50",
        border: "border-emerald-200",
        text: "text-emerald-700",
        dot: "bg-emerald-500",
    },
    {
        value: "TRADE",
        label: "Trade",
        short: "Direkter Handel",
        description: "Aktiver Handel / kurzfristige Veräußerung.",
        color: "orange",
        bg: "bg-orange-50",
        border: "border-orange-200",
        text: "text-orange-700",
        dot: "bg-orange-500",
    },
    {
        value: "HOLD_THEN_SELL",
        label: "Hold → Sell",
        short: "Verkauf nach Frist",
        description: "Bestand halten, dann veräußern (Spekulationsfrist o.ä.).",
        color: "sky",
        bg: "bg-sky-50",
        border: "border-sky-200",
        text: "text-sky-700",
        dot: "bg-sky-500",
    },
];

export const STRATEGY_BY_VALUE = Object.fromEntries(LIFECYCLE_STRATEGIES.map((s) => [s.value, s]));

// Vordefinierte Stati — die Liste darf vom User über das Eingabefeld auch frei erweitert werden.
// strategy-Filter zeigt nur die jeweils passenden Vorschläge an.
export const LIFECYCLE_STATUSES = [
    // Track HOLD / HOLD_THEN_SELL relevant
    { value: "ruhend",           label: "Ruhend",                 hint: "Alles in Ordnung", strategies: ["HOLD", "HOLD_THEN_SELL"] },
    { value: "instandhaltung",   label: "Instandhaltung",         strategies: ["HOLD", "HOLD_THEN_SELL"] },
    { value: "modernisierung",   label: "Modernisierung",         strategies: ["HOLD", "HOLD_THEN_SELL"] },
    { value: "sanierung",        label: "Sanierung",              strategies: ["HOLD", "HOLD_THEN_SELL", "TRADE"] },
    { value: "neuvermietung",    label: "Neuvermietung",          strategies: ["HOLD", "HOLD_THEN_SELL"] },
    { value: "mietminderung",    label: "Mietminderung",          strategies: ["HOLD", "HOLD_THEN_SELL"] },
    { value: "rechtsstreit",     label: "Rechtsstreit",           strategies: ["HOLD", "HOLD_THEN_SELL", "TRADE"] },
    // Track TRADE / HOLD_THEN_SELL relevant
    { value: "aufbereitung",     label: "Aufbereitung",           strategies: ["TRADE", "HOLD_THEN_SELL"] },
    { value: "vermarktung",      label: "Vermarktung",            strategies: ["TRADE", "HOLD_THEN_SELL"] },
    { value: "kaufvertrag_verh", label: "Kaufvertrag-Verhandlung", strategies: ["TRADE", "HOLD_THEN_SELL"] },
    { value: "notartermin",      label: "Notartermin",            strategies: ["TRADE", "HOLD_THEN_SELL"] },
    { value: "uebertragen",      label: "Übertragen",             strategies: ["TRADE", "HOLD_THEN_SELL"] },
];

export const STATUS_BY_VALUE = Object.fromEntries(LIFECYCLE_STATUSES.map((s) => [s.value, s]));

export function statusLabel(value) {
    return STATUS_BY_VALUE[value]?.label || (value
        ? value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
        : "—");
}

export function statusesForStrategy(strategy) {
    return LIFECYCLE_STATUSES.filter((s) => s.strategies.includes(strategy));
}

export const TASK_PRIORITIES = [
    { value: "hoch", label: "Hoch", color: "text-red-600", dot: "bg-red-500" },
    { value: "normal", label: "Normal", color: "text-slate-600", dot: "bg-slate-400" },
    { value: "niedrig", label: "Niedrig", color: "text-gray-400", dot: "bg-gray-300" },
];

export const PRIO_BY_VALUE = Object.fromEntries(TASK_PRIORITIES.map((p) => [p.value, p]));
